import * as React from "react"
import * as semver from "semver"
import { useSiteDependencies } from "@modules/site/details/hooks/useSiteDependencies"

export function useSiteDependencyInfo(
  siteId: string,
  gatsbyVersion = `>=4.0.0`
) {
  const { siteDependencies } = useSiteDependencies(siteId)

  // memoize the value so that it doesn't trigger re-renders
  const isCompatibleGatsbyVersion = React.useMemo(
    () =>
      siteDependencies.some(
        item =>
          item.name === "gatsby" &&
          (semver.satisfies(
            semver.coerce(item.installedVersion) || "",
            gatsbyVersion
          ) ||
            !/\d/.test(item.installedVersion || "") ||
            semver.prerelease(item.installedVersion || ""))
      ),
    []
  )
  return { siteDependencies, isCompatibleGatsbyVersion }
}
